import type { BoggleChallengeCoreInfo } from './types'

export function getSprintChallengeIntervalCountInfo(
  intervalCount: number,
): BoggleChallengeCoreInfo<number> {
  if (intervalCount <= 8) {
    return {
      id: 'few-intervals',
      tierLabel: 'Few',
    }
  } else if (intervalCount <= 11) {
    return {
      id: 'normal-intervals',
      tierLabel: 'Normal',
    }
  } else {
    return {
      id: 'many-intervals',
      tierLabel: 'Many',
    }
  }
}

export function getSprintChallengeIntervalTimeInfo(
  intervalTimeSeconds: number,
): BoggleChallengeCoreInfo<number> {
  if (intervalTimeSeconds <= 12) {
    return {
      id: 'fast-sprint',
      tierLabel: 'Fast',
    }
  } else if (intervalTimeSeconds <= 19) {
    return {
      id: 'normal-sprint',
      tierLabel: 'Normal',
    }
  } else {
    return {
      id: 'slow-sprint',
      tierLabel: 'Slow',
    }
  }
}
